import { render, staticRenderFns } from "./PrivateLessons.vue?vue&type=template&id=39085044&"
import script from "./PrivateLessons.vue?vue&type=script&lang=js&"
export * from "./PrivateLessons.vue?vue&type=script&lang=js&"
import style0 from "./PrivateLessons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PrivateLessons.vue"
export default component.exports